module.exports = __webpack_public_path__ + "assets/img/4ea19b003f45d0f7b1f15a0b5fb7ee24.png";